export enum PageLocation {
    CART = 'cart',
    CHECKOUT = 'checkout',
}
